import { ChangeDetectionStrategy, Component, ElementRef, Inject, QueryList, ViewChildren } from '@angular/core';
import { MAT_MENU_DEFAULT_OPTIONS, MatMenuDefaultOptions } from '@angular/material/menu';
import { Router } from '@angular/router';
import { GeneralRemoteControllerService } from 'core/api';
import { SS_VERSION } from 'core/config';
import { subjectFromObs } from 'core/rx-js';
import { BehaviorSubject, combineLatest, distinctUntilChanged, map, startWith, Subject, take } from 'rxjs';
import { designerPaths } from '../../../designer.paths';
import { JwtRefreshService } from '../../../global-services/jwt-refresh.service';
import { UserService } from '../../../global-services/user.service';
import { SidenavService } from '../sidenav.service';

@Component({
  selector: 'ss-sidenav-content',
  templateUrl: './sidenav-content.component.html',
  styleUrls: ['./sidenav-content.component.scss'],
  host: {
    class: 'position-relative z-10000'
  },
  providers: [
    {
      provide: MAT_MENU_DEFAULT_OPTIONS,
      useValue: {
        overlayPanelClass: ['sidenav-panel', 'primary-background', 'border-radius-small'],
      } as MatMenuDefaultOptions
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidenavContentComponent {

  readonly #destroy = new Subject<void>()



  readonly LOGO_PATH = './assets/logo.png'
  readonly rotateObs = this._sidenavService.rotateObs;
  readonly expandedSubject = this._sidenavService.expandedSubject;




  readonly isSmallScreenSubject = this._sidenavService.isSmallScreenSubject;


  @ViewChildren('bottomDiv')
  private _bottomDivQL: QueryList<ElementRef<HTMLDivElement>>
  @ViewChildren('topDiv')
  private _topDivQL: QueryList<ElementRef<HTMLDivElement>>

  readonly bottomDivSubject = new BehaviorSubject<HTMLElement>(null);
  readonly topDivSubject = new BehaviorSubject<HTMLElement>(null);

  readonly otherElementsSubject = subjectFromObs({
    initialValue: null,
    observable: combineLatest([this.bottomDivSubject, this.topDivSubject]).pipe(
      map((arr) => arr.filter(Boolean))
    ),
    until: this.#destroy
  })

  constructor(
    private readonly _sidenavService: SidenavService,
    private readonly _jwtRefreshService: JwtRefreshService,
    private readonly _router: Router,
    private readonly _userService: UserService,
    private readonly _generalRemoteControllerService: GeneralRemoteControllerService,
    @Inject(SS_VERSION)
    private readonly _version: string
  ) {






  }

  ngAfterViewInit() {

    this._bottomDivQL.changes.pipe(
      startWith(this._bottomDivQL),
      map((ql: QueryList<ElementRef<HTMLDivElement>>) => ql.first),
      distinctUntilChanged()
    )
      .subscribe(bottomDiv => {
        this.bottomDivSubject.next(bottomDiv?.nativeElement);
      })


    this._topDivQL.changes.pipe(
      startWith(this._topDivQL),
      map((ql: QueryList<ElementRef<HTMLDivElement>>) => ql.first),
      distinctUntilChanged()
    )
      .subscribe(topDiv => {
        this.topDivSubject.next(topDiv?.nativeElement);
      })
  }


  toggleExpanded() {
    this._sidenavService.toggleExpanded();
  }

  logout() {

    this._jwtRefreshService.logout()
      .pipe(take(1))
      .subscribe(() => {
        this._router.navigate([designerPaths.auth]);
      });
  }


  goToUserSettings() {
    this._userService.goToUserSettings();
  }

  handleReroute() {
    this._sidenavService.handleReroute()
  }

  ngOnDestroy() {
    this.#destroy.next()
    this.#destroy.complete()
  }
}
